'use es6';

import { Component } from 'react';
import { NEW_RELIC_ERROR_KEY } from '../constants';
export default class ErrorBoundary extends Component {
  static getDerivedStateFromError() {
    return {
      hasError: true
    };
  }
  constructor(props) {
    super(props);
    this.state = {
      hasError: false
    };
  }
  componentDidCatch(error, errorInfo) {
    if (window.newrelic && window.newrelic.noticeError) {
      // Log our own error in New Relic
      window.newrelic.noticeError(error, {
        [NEW_RELIC_ERROR_KEY]: true
      });
    }
    console.error(error);
    console.info(errorInfo.componentStack);
  }
  render() {
    if (this.state.hasError) {
      return null;
    }
    return this.props.children;
  }
}